import React from "react";
import { Helmet } from "react-helmet";

const AnalyticsTag = () => {
  return (
    <Helmet>
      {/* Load gtag.js once with any one of the IDs (GA or Ads) */}
      {/* <script async src="https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXXXX"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          // Google Analytics ID
          gtag('config', 'G-XXXXXXXXXX');

          // Google Ads ID
          gtag('config', 'AW-YYYYYYYYYY');
        `}
      </script> */}

      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-17311900441"></script>
      <script>{`
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments)}
  gtag('js', new Date());

  gtag('config', 'AW-17311900441');
`}</script>
    </Helmet>
  );
};

export default AnalyticsTag;
